import BillingsOrderCargoRailyDraftResponse, {
  BillingsOrderCargoRailyDraftResponseDataContractCargoCompany,
  BillingsOrderCargoRailyDraftResponseDataContractBillingModel,
  BillingsOrderCargoRailyDraftResponseDataContract,
  BillingsOrderCargoRailyDraftResponseDataBillingNode,
  BillingsOrderCargoRailyDraftResponseDataCargoOrder,
} from "../../../../../api/raily/billings/order/cargo-raily/draft/billings-order-cargo-raily-draft.response";
import BillingModel from "../../../../../types/billing-model";
import BillingsOrderCargoRailyDraft, {
  BillingsOrderCargoRailyDraftContractCargoCompany,
  BillingsOrderCargoRailyDraftContract,
  BillingsOrderCargoRailyDraftBillingNode,
  BillingsOrderCargoRailyDraftCargoOrder,
} from "./billings-order-cargo-raily-draft";

const createContractCargoCompany = (
  cargoCompany: BillingsOrderCargoRailyDraftResponseDataContractCargoCompany,
): BillingsOrderCargoRailyDraftContractCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
  };
};

const createContractModel = (
  model: BillingsOrderCargoRailyDraftResponseDataContractBillingModel,
): BillingModel => {
  switch (model) {
    case BillingsOrderCargoRailyDraftResponseDataContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderCargoRailyDraftResponseDataContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderCargoRailyDraftResponseDataContractBillingModel.OTHER:
      return BillingModel.OTHER;
    case BillingsOrderCargoRailyDraftResponseDataContractBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createContract = (
  contract: BillingsOrderCargoRailyDraftResponseDataContract,
): BillingsOrderCargoRailyDraftContract => {
  return {
    allowChargeDuringRide: contract.allowChargeDuringRide,
    allowChargeWhileApproaching: contract.allowChargeWhileApproaching,
    allowChargeWhileReturning: contract.allowChargeWhileReturning,
    cargoCompany: createContractCargoCompany(contract.cargoCompany),
    discountLimit: contract.discountLimit,
    distanceRate: contract.distanceRate,
    haltingTimeAfterMinutes: contract.haltingTimeAfterMinutes,
    haltingTimeRate: contract.haltingTimeRate,
    model: createContractModel(contract.model),
  };
};

const createBillingNode = (
  billingNode: BillingsOrderCargoRailyDraftResponseDataBillingNode,
): BillingsOrderCargoRailyDraftBillingNode => {
  return {
    allowCharge: billingNode.allowCharge,
    checkoutDate: billingNode.checkoutDate,
    checkoutEventId: billingNode.checkoutEventId,
    description: billingNode.description,
    distance: billingNode.distance,
    editableCoordinates: billingNode.editableCoordinates,
    haltingTime: billingNode.haltingTime,
    highwayCharge: billingNode.highwayCharge,
    id: billingNode.id,
    lat: billingNode.lat,
    lon: billingNode.lon,
    nodeId: billingNode.nodeId,
    orderId: billingNode.orderId,
    plannedDate: billingNode.plannedDate,
    plannedDistance: billingNode.plannedDistance,
  };
};

const createBillingNodes = (
  billingNodes: BillingsOrderCargoRailyDraftResponseDataBillingNode[],
): BillingsOrderCargoRailyDraftBillingNode[] => {
  return billingNodes.map(createBillingNode);
};

const createCargoOrder = (
  cargoOrder: BillingsOrderCargoRailyDraftResponseDataCargoOrder,
): BillingsOrderCargoRailyDraftCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
    id: cargoOrder.id,
  };
};

const create = (
  response: BillingsOrderCargoRailyDraftResponse,
): BillingsOrderCargoRailyDraft => {
  const data = response.data;

  return {
    billingNodes: createBillingNodes(data.billingNodes),
    cargoOrder: createCargoOrder(data.cargoOrder),
    contract: createContract(data.contract),
    date: data.date,
    discount: data.discount,
    discountAmount: data.discountAmount,
    distance: data.distance,
    distanceAmount: data.distanceAmount,
    haltingAmount: data.haltingAmount,
    highwayCharge: data.highwayCharge,
    planEntryId: data.planEntryId,
    totalAmount: data.totalAmount,
  };
};

const billingsOrderCargoRailyDraftFactory = {
  create,
};

export default billingsOrderCargoRailyDraftFactory;
